import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import RadioButton from '../components/radio-button';
import RadioButtonGroupContext from '../context';
import { TOOLTIP_PROP_TYPES } from '../../tooltip/types';

const RadioButtonContainer = ({
  disabled = false,
  id,
  label,
  tooltipProps = null,
  value,
  isLabelBold = false,
}) => {
  const { defaultSelectedValue, name, onChange, selectedValue } =
    useContext(RadioButtonGroupContext);
  const isChecked = selectedValue === undefined ? undefined : selectedValue === value;
  const isDefaultChecked =
    defaultSelectedValue === undefined ? undefined : defaultSelectedValue === value;

  return (
    <RadioButton
      checked={isChecked}
      defaultChecked={isDefaultChecked}
      disabled={disabled}
      id={id}
      label={label}
      name={name}
      onChange={onChange}
      tooltipProps={tooltipProps}
      value={value}
      isLabelBold={isLabelBold}
    />
  );
};

RadioButtonContainer.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  tooltipProps: PropTypes.shape(TOOLTIP_PROP_TYPES),
  value: PropTypes.string.isRequired,
  isLabelBold: PropTypes.bool,
};

export default RadioButtonContainer;
